import * as yup from 'yup';

import CrudPage from '@modules/cruds/CrudPage';
import FormImage from './DocumentForm';
import { defaultConfigComponent } from './Documents';

const documentSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
  // logicalId: yup.string().required().label("Logical ID"),
  //purposeId: yup.string().required().label('Purpose'),
  //locator: yup.string().required().label('Document').nullable(),
});

const DocumentPage = props => {
  const { app } = props;
  const loggedUserId = app.getIn(['cx', 'data', 'sessionBadge', 'userId']);

  return (
    <CrudPage
      key={'documentPage'}
      configComponent={defaultConfigComponent}
      form={FormImage}
      defaultValues={{ ownerUserId: loggedUserId }}
      validationSchema={documentSchema}
    />
  );
};

export default DocumentPage;
